import Ajax from "Utils/ajax";
export const getAwardList = (data) => Ajax.post('admin/getAwardList',data);
export const addUpdateAward = (data) => Ajax.post('admin/addUpdateAward',data);
export const deleteAward = (data) => Ajax.post('admin/deleteAward',data);